import React from 'react'
import { intComma } from 'humanize-plus'
import { Div, Span } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { Icon } from '@driftt/tide-icons'
import cx from 'classnames'

import './style.css'

const sizeOptions = [{label: 25, value: 25}, {label: 50, value: 50}, {label: 75, value: 75}]

const Paginator = ({ totalPages, index, goForward, goBackward, changeSize, size }) => {
	const canGoBack = !index
	const canGoForwards = (index + 1) >= totalPages
	const selectValue = sizeOptions.filter(({ value }) => value === size)

	return (
		<Div className="contacts-table-paginator">
      <Select menuPlacement="top" options={sizeOptions} clearable={false} value={selectValue} onChange={changeSize} className="contacts-table-paginator-size-select" />
			<Div className="paginator-navigation">
	    	{totalPages > 1 && <button onClick={goBackward} disabled={canGoBack}><Icon width={12} height={12} name="arrow-1-left" /></button>}
	    	<Span>Page {index + 1} of {intComma(totalPages) || 1}</Span>
	    	{totalPages > 1 && <button disabled={canGoForwards} onClick={goForward}><Icon width={12} height={12} name="arrow-1-right" /></button>}
			</Div>
		</Div>
	)
}

export const NoMaxPagesPaginator = ({ goBackward, goForward, index, pageSize }) => {
	const currentPage = Math.floor(index / pageSize) + 1
	const showGoBack = index > 0
	const showGoForward = true

	const goBackClassName = cx({ 'paginator-button--hidden': !showGoBack })
	const goForwardClassName = cx({ 'paginator-button--hidden': !showGoForward })

	return (
		<Div className="contacts-table-paginator">
			<Div className="paginator-navigation">
				<button onClick={goBackward} className={goBackClassName}>
					<Icon width={12} height={12} name="arrow-1-left" />
				</button>
				Page {currentPage}
				<button onClick={goForward} className={goForwardClassName}>
					<Icon width={12} height={12} name="arrow-1-right" />
				</button>
			</Div>
		</Div>
	)
}

export default Paginator
